module.exports = __webpack_public_path__ + "static/img/code.8a29beda.png";